'use strict';

angular.module('impactx.panel')
    .directive('ixPanel', ['$sce', function ($sce) {
        return {
            scope: {
                type: '@typeAttr',
                image: '@imageAttr',
                description: '@descriptionAttr',
                name: '@nameAttr',
                labelclass: '@labelclassAttr',
                tileclass: '@tileclassAttr',
                destination: '@destination'
            },
            controller: 'PanelCtrl',
            controllerAs: 'panelCtrl',
            transclude: true,
            templateUrl: 'shared/panel/templates/panel.tmpl.html',
            link: function (scope) {
                scope.backupImage = "img/missing-image.jpg";
                scope.desc = $sce.trustAsHtml(scope.description);
            }
        }
    }]);
